module.exports = __webpack_public_path__ + "Loader2.svg?a6653612c8c8970706f38ad3dd49dd8f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Loader2.svg
// module id = 205
// module chunks = 354